import Leaderboard from "components/Leaderboard";

export default function AllTimeLeaderboard() {
  return <Leaderboard type="seasonal" />;
}
